import { Typewriter } from 'react-simple-typewriter';

function Header() {
  return (
    <header className="header">
      <h1 className="title">
        <Typewriter
          words={["Catat tugas kamu hari ini."]}
          cursor
          cursorStyle="|"
          typeSpeed={80}
        />
      </h1>
      <p className="subtitle">Sederhana, rapi, dan fokus ke hal yang perlu kamu kerjakan.</p>
    </header>
  );
}

export default Header;
